import React, {FC} from 'react';
import {View} from 'react-native';

import ScrollContainer from '@/components/ScrollContainer';
import SocialShareButtons from '@/components/SocialShareButtons';
import Text from '@/components/Text';
import {
  OwnedTrackTile,
  EtherscanLink,
  JiffyscanLink,
} from '@/modules/Transactions';
import {useTransferState} from '@/modules/Transfer/TrackTransfer/useTransferState';
import {useThemedStyles} from '@/theme';
import {prettifyAddress} from '@/utils/ethereum';
import {
  shareTxSuccessOnLens,
  shareTxSuccessOnTwitter,
  shareTxSuccessOnWarpcast,
} from '@/utils/share';

import {styles} from './SuccessfulTransfer.style';

interface IProps {}

const SuccessfulTransfer: FC<IProps> = ({}) => {
  const style = useThemedStyles(styles);
  const {transfer, user, track} = useTransferState();
  const {txHash, userOpHash, chainId} = transfer;

  return (
    <ScrollContainer contentStyle={style.scrollContent}>
      {user && <OwnedTrackTile user={user} track={track} />}
      <View style={style.content}>
        <Text
          weight="semibold"
          size="l"
          id="transfer.success.title"
          align="center"
        />

        <View style={style.textsContainer}>
          <Text
            id="transfer.success.description1"
            align="center"
            values={{
              track: (
                <Text weight="semibold" align="center">
                  {track.title}
                </Text>
              ),
              artist: track.artist.name,
              address: transfer.to && prettifyAddress(transfer.to),
            }}
          />
          <Text id="transfer.success.description2" align="center" />
        </View>

        <View style={style.shareContainer}>
          <SocialShareButtons
            shareOnTwitter={() => shareTxSuccessOnTwitter(track)}
            shareOnLens={() => shareTxSuccessOnLens(track)}
            shareOnWarpcast={() => shareTxSuccessOnWarpcast(track)}
          />
        </View>
      </View>

      <View style={style.transactionLinks}>
        {(txHash || userOpHash) && (
          <View style={style.links}>
            {userOpHash && (
              <View style={style.link}>
                <JiffyscanLink userOpHash={userOpHash} chainId={chainId} />
              </View>
            )}
            {txHash && (
              <View style={style.link}>
                <EtherscanLink txHash={txHash} chainId={chainId} />
              </View>
            )}
          </View>
        )}
      </View>
    </ScrollContainer>
  );
};

export default SuccessfulTransfer;
